import { useQuery } from '@tanstack/react-query';

import Group from 'models/Group';
import { GroupAccessMode, groupsQueryKeys, indexGroups } from 'services/api/group';

// Stable identity for the unresolved state — avoids creating a new [] on every render,
// which would invalidate downstream memos and effects that depend on the result. Typed as the
// resolved element type (Group) so consumers get the full facility shape, not just {id, name}.
const EMPTY_FACILITIES: Group[] = [];

// The buildings the current user may address a referral to. Callers scope by provider type:
// referral creation/editing pass a specific `type` (Skilled Nursing only — OLIO-3344), while
// the portal-retrieval facility screens pass nothing and get every provider type the user
// operates (they legitimately retrieve referrals for non-SNF facilities). The resolved params
// are folded into the query key, so each scope is its own cache entry rather than colliding.
export function useAllowedFacilities({ type }: { type?: string } = {}) {
  const params = {
    accessModes: [GroupAccessMode.Allowed],
    pageSize: 200,
    sortBy: 'name',
    ...(type ? { type } : { isProvider: true }),
  };

  const query = useQuery({
    queryKey: [...groupsQueryKeys.index, params],
    queryFn: ({ signal }) => indexGroups(params, signal),
  });

  return { facilities: query.data?.data ?? EMPTY_FACILITIES, isPending: query.isPending };
}
